(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    // Shopify's consent banner exposes window.privacyBanner once storefront-banner.js has loaded.
    const upgrade = () => {
      const api = window.privacyBanner;
      if (!api || typeof api.showPreferences !== 'function') return false;
      document.querySelectorAll('a[data-cookie-settings]').forEach((a) => {
        if (a.dataset.upgraded) return;
        a.dataset.upgraded = '1';
        a.setAttribute('role', 'button');
        a.addEventListener('click', (e) => { e.preventDefault(); api.showPreferences(); });
      });
      return true;
    };
    let tries = 0;
    const poll = () => { if (!upgrade() && ++tries < 20) setTimeout(poll, 500); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poll); else poll();
    document.addEventListener('shopify:section:load', poll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    // Full-screen viewer: open at the clicked image (loot.js opens the dialog itself).
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-viewer-media]');
      if (!opener) return;
      const dialog = document.getElementById(opener.getAttribute('data-open-dialog'));
      if (!dialog) return;
      requestAnimationFrame(() => {
        const item = dialog.querySelector(`[data-viewer-item="${opener.getAttribute('data-viewer-media')}"]`);
        if (item) item.scrollIntoView({ block: 'start' });
      });
    });

    // Sticky buy bar: sit above Shopify's cookie banner while it is visible (DESIGN.md §8).
    const lootBuybarBanner = () => {
      const root = document.documentElement;
      const sync = () => {
        const banner = document.getElementById('shopify-pc__banner');
        let h = 0;
        if (banner) {
          const cs = getComputedStyle(banner);
          const r = banner.getBoundingClientRect();
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < innerHeight) h = Math.min(innerHeight * 0.6, Math.max(0, innerHeight - r.top));
        }
        root.style.setProperty('--pc-banner-h', `${Math.round(h)}px`);
      };
      let watched = null;
      const watch = () => {
        const banner = document.getElementById('shopify-pc__banner');
        if (banner && banner !== watched) {
          watched = banner;
          new MutationObserver(sync).observe(banner, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden'] });
          if ('ResizeObserver' in window) new ResizeObserver(sync).observe(banner);
        }
        sync();
      };
      if (!document.querySelector('[data-sticky-bar]') && !document.querySelector('[data-product-section]')) return;
      new MutationObserver(watch).observe(document.body, { childList: true });
      window.addEventListener('resize', sync, { passive: true });
      watch();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lootBuybarBanner);
    else lootBuybarBanner();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-withdrawal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'loot-withdrawal';
    const fill = (root, data) => {
      Object.entries(data).forEach(([k, v]) => {
        root.querySelectorAll(`[data-withdrawal-out="${k}"]`).forEach((row) => {
          const dd = row.querySelector('dd');
          const empty = row.closest('[data-withdrawal-review]') ? row.dataset.empty || '' : '';
          if (dd) dd.textContent = v || empty;
          row.hidden = !v && !row.closest('[data-withdrawal-review]');
        });
      });
    };
    const init = (form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const receipt = form.querySelector('.withdrawal__receipt');
      if (receipt) {
        let saved = null;
        try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) {}
        if (saved) {
          fill(receipt, saved);
          const t = receipt.querySelector('[data-withdrawal-time]');
          if (t && saved.time) t.textContent = saved.time;
        }
        receipt.querySelector('[data-withdrawal-print]')?.addEventListener('click', () => window.print());
        receipt.focus();
        return;
      }
      const step1 = form.querySelector('[data-withdrawal-step="1"]');
      const field = (sel) => form.querySelector(sel);
      const read = () => ({
        name: field('[name="contact[name]"]').value.trim(),
        email: field('[name="contact[email]"]').value.trim(),
        order: field('[id$="-order"]').value.trim(),
        products: field('[id$="-products"]').value.trim(),
      });
      const review = form.querySelector('[data-withdrawal-review]');
      const productsRow = review && review.querySelector('[data-withdrawal-out="products"]');
      if (productsRow) productsRow.dataset.empty = form.dataset.allProducts || '';
      form.dataset.step = '1';
      form.querySelector('[data-withdrawal-next]')?.addEventListener('click', () => {
        const fields = [...step1.querySelectorAll('input, textarea')];
        const invalid = fields.find((f) => !f.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        fill(review, read());
        form.dataset.step = '2';
        form.querySelector('[data-withdrawal-step="2"] .withdrawal__legend')?.setAttribute('tabindex', '-1');
        form.querySelector('[data-withdrawal-step="2"] .withdrawal__legend')?.focus();
      });
      form.querySelector('[data-withdrawal-back]')?.addEventListener('click', () => {
        form.dataset.step = '1';
        field('[name="contact[name]"]').focus();
      });
      form.addEventListener('submit', () => {
        const d = read();
        const time = new Date().toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short' });
        const body = form.querySelector('[data-withdrawal-body]');
        if (body) {
          body.value = [form.dataset.bodyIntro || '', `Namn: ${d.name}`, `E-post: ${d.email}`, `Order: ${d.order}`, `Produkter: ${d.products || form.dataset.allProducts || ''}`, `Tid: ${time}`].join('\n');
        }
        try { sessionStorage.setItem(KEY, JSON.stringify({ ...d, time })); } catch (e) {}
      });
    };
    const run = () => document.querySelectorAll('form[data-withdrawal]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // <product-recs>: fill the related rail ("Mer från {set}", else Shopify recommendations).
  if (!customElements.get('product-recs')) {
    customElements.define('product-recs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = '1';
        this.load();
      }
      async fetchItems(url) {
        if (!url) return null;
        try {
          const res = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!res.ok) return null;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const inner = doc.querySelector('[data-recs-inner]');
          if (!inner) return null;
          const limit = Number(this.dataset.limit) || 10;
          const items = [...inner.querySelectorAll('[data-recs-handle]')];
          items.forEach((li) => { if (li.dataset.recsHandle === this.dataset.handle) li.remove(); });
          const left = [...inner.querySelectorAll('[data-recs-handle]')];
          left.slice(limit).forEach((li) => li.remove());
          return left.length ? inner : null;
        } catch (e) {
          return null;
        }
      }
      async load() {
        const inner = (await this.fetchItems(this.dataset.setUrl)) || (await this.fetchItems(this.dataset.recsUrl)) || (await this.fetchItems(this.dataset.typeUrl));
        if (inner) this.replaceChildren(...inner.childNodes);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
